module.exports = __webpack_public_path__ + "static/VOTLogo-e567e270cc56ad3aac277df593c1f28d.png";